import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { THREADS_UPDATED_BULK_NOTIFICATION } from 'conversations-inbox-lib/threads-bulk-update/public/constants';
import { createAction } from 'redux-actions';
import { jsx as _jsx } from "react/jsx-runtime";
export const bulkUpdateSucceededNotification = createAction(THREADS_UPDATED_BULK_NOTIFICATION, () => {}, threadCount => {
  return {
    notification: {
      titleText: I18n.text('ConversationsInboxUI.threadBatchOperations.succeeded.title'),
      timeout: 3000,
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ConversationsInboxUI.threadBatchOperations.succeeded.message",
        options: {
          count: threadCount
        }
      }),
      type: 'info'
    }
  };
});